import orderSlice from "./orderSlice";
import detailOrderSlice from "./detailOrderSlice";

export const orderReducers = {
    orderSlice,
    detailOrderSlice
}

